export const MainConfig = {
    AppDetails: {
        app_name: "Drivers On Demand",
        app_description: "Drivers On Demand",
        app_identifier: "com.drivers.ondemand",
        ios_app_version: "1.0.0",
        android_app_version: 1
    },

    FirebaseConfig: {
        apiKey: "AIzaSyAMeRel8DxN8vrdU6D1GpmPZilsJrvfmCE",
        authDomain: "drivers-ondemand.firebaseapp.com",
        databaseURL: "https://drivers-ondemand-default-rtdb.firebaseio.com",
        projectId: "drivers-ondemand",
        storageBucket: "drivers-ondemand.appspot.com",
        messagingSenderId: "390239955596",
        appId: "1:390239955596:web:5fc2e6df461fa2abc829a9",
        measurementId: "G-YDEETRVRQG"
    },

    Google_Map_API_Key: {
        ios: "AIzaSyD6im1eA7SGSTJnyqVIqPazPxaq6GHjFHk",
        android: "AIzaSyBZgQ4LsmbKg9tmc-hbMGM7KrTLWsQO6Uw",
        web: "AIzaSyAMeRel8DxN8vrdU6D1GpmPZilsJrvfmCE",
    },
    Expo: {
        projectId: ""
      }
}